import React, {useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import DatePicker from "react-datepicker2";
import "./user.css";
import moment from 'moment-jalaali';
import {notification} from "../../functions/notification/notificationFunction";
import {createAdmin, editAdmin, getAdminById} from "../../../stores/admin/adminThunk";
import {initAdminForm, onAdminFormChange, selAdminForm} from "../../../stores/admin/adminSlice";
import {adminValidations, FormAdminInit} from "../../../stores/admin/adminModel";

export default function AdminUser() {

    const admin = useSelector(selAdminForm);

    const { first_name, last_name, mobile, national_code, username, password } = admin;
    const provinces = [
        {
            name: "مرد",
            value: 21
        },
        {
            name: "زن",
            value: 20
        }
    ];
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const [newPass, setNewPass] = useState("")

    const {errors, checkFiled, checkValidation} = useValidation({
        data: adminValidations,
        key: 'adminForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onAdminFormChange({name, value}))
    }

    function backToUsers() {
        history.push('/adminUsers');
    }

    const redirectToUsers =()=> history.push("/adminUsers")

    async function addUser(){
        const data = {
            first_name: first_name,
            last_name: last_name,
            mobile: mobile,
            national_code: national_code,
            username: username,
            password: password
        }

        const check = await checkValidation(data);
        if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(createAdmin(data, redirectToUsers))
    }

    async function putUser(){
        const data = {
            first_name: first_name,
            last_name: last_name,
            mobile: mobile,
            national_code: national_code,
            username: username,
        }
        const data1 = {
            first_name: first_name,
            last_name: last_name,
            mobile: mobile,
            national_code: national_code,
            username: username,
            password: password
        }
        const check = await checkValidation(password !== "" ? data1 : data);
        if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(editAdmin(id, password !== "" ? data1 : data , redirectToUsers))
    }

    function setTime(e, name) {
        const value = moment(e).format(`YYYY-MM-DD`)
        checkFiled(name, moment(e).format(`YYYY-MM-DD`));
        dispatch(onAdminFormChange({name, value: moment(e).format(`YYYY-MM-DD`)}))
        // setStaticState(prevState => (
        //     {
        //         ...prevState, [name]: e.format(`jYYYY/jMM/jDD`),
        //         [`dateForSend`]: e.format(`YYYY/MM/DD`)
        //     }
        // ));
    }


    useEffect(() => {
        id ?
            dispatch(getAdminById({id}))
            :
            dispatch(initAdminForm(FormAdminInit))
        return ()=>{
            dispatch(initAdminForm(FormAdminInit))
        }
    }, [id]);

    console.log( first_name, last_name, mobile, national_code, username, password )
    console.log(errors)

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن مدیر"
                backBtnTitle="بازگشت"
                backBtnAction={backToUsers}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام'}
                                        variant="outlined"
                                        name={'first_name'}
                                        value={first_name}
                                        error={errors.first_name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام خانوادگی'}
                                        variant="outlined"
                                        name={'last_name'}
                                        value={last_name}
                                        error={errors.last_name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'موبایل'}
                                        variant="outlined"
                                        name={'mobile'}
                                        value={mobile}
                                        error={errors.mobile}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'کد ملی'}
                                        variant="outlined"
                                        name={'national_code'}
                                        value={national_code}
                                        error={errors.national_code}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام کاربری'}
                                        variant="outlined"
                                        name={'username'}
                                        value={username}
                                        error={errors.username}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'رمز عبور'}
                                        variant="outlined"
                                        name={'password'}
                                        value={password}
                                        error={errors.password}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'رمز عبور'}
                                        variant="outlined"
                                        value={newPass}
                                        error={errors.password}
                                        className={`w-100`}
                                        onChange={(e)=> setNewPass(e.target.value) }
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putUser : addUser }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            {id ? "ویرایش" : "ایجاد"}
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
